import { Observable, of, throwError } from 'rxjs';
import { retryWhen, mergeMap, delay, filter } from 'rxjs/operators';

const getErrorMessage = (maxRetry: number) =>
  `Se intento cargar el recurso ${maxRetry} veces sin exito. Por favor recargar la página para volver a intentar.`;

const DEFAULT_MAX_RETRIES = 3;
const DEFAULT_BACKOFF = 500;

export function retryWithBackoff(delayMs: number, maxRetry = DEFAULT_MAX_RETRIES, backoffMs = DEFAULT_BACKOFF) {
  let retries = maxRetry;

  return (src: Observable<any>) =>
    src.pipe(
      retryWhen((errors: Observable<any>) => errors.pipe(
        mergeMap(error => {
          // const shouldRetry = error.status in [502, 503 , 504, 404, 408];
          const shouldRetry = [502, 503, 504, 404, 408].includes(error.status);
          if (shouldRetry) {
            if (retries-- > 0) {
              const backOffTime = delayMs + (maxRetry - retries) * backoffMs;
              return of(error).pipe(delay(backOffTime));
            }
            return throwError(getErrorMessage(maxRetry));
          } else {
            return throwError(error);
          }
        })
      ))
    );
}


